import { Accordion } from "react-bootstrap";
import parse from 'html-react-parser';

const Itinerary = ({ safariViewData }) => {

    return (
            <div id="itenery-tab-pane" role="tabpanel" aria-labelledby="itenery-tab" className="tab-pane accordion-item mb-3">
                <div className="card bg-set accordion-collapse  card_bodyPadding">
                    <div className="card-body p-3">
                        <div className="itenary-title">
                            <h6 className="fs-6 fw-bold mb-4">itinerary</h6>
                        </div>
                        <div className="row ">
                            <div className="col-12 inner_accordion">
                                <Accordion defaultActiveKey="" flush id="accordionFlushExample">
                                    {Array.isArray(safariViewData?.sharesafaridays) && safariViewData?.sharesafaridays?.length > 0 ? (
                                        safariViewData?.sharesafaridays.map((packageday, index) => (
                                            <Accordion.Item key={index} eventKey={index.toString()} className="accordion-item mb-3">
                                                <Accordion.Header className="accordion-header" id={`flush-heading${packageday.day}`}>
                                                    DAY {packageday.day} - {packageday.day_title}
                                                </Accordion.Header>
                                                <Accordion.Body>
                                                    <div className="wrap_days">
                                                        <div className="row">
                                                            <div className="col-12">
                                                                {packageday.day_description && parse(packageday.day_description)}
                                                            </div>
                                                        </div>


                                                    </div>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        ))
                                    ) : (
                                        <p>No itinerary available.</p>
                                    )}
                                </Accordion>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    )
}

export default Itinerary